import { useCallback } from 'react';
import { useAnalytics } from '../context/AnalyticsContext';

/**
 * Ürün etkileşim takibi için custom hook (JSONB Format)
 * Ürün görüntüleme, tıklama, sepete ekleme gibi etkileşimleri takip eder
 */
export const useProductTracking = () => {
  const { trackProductInteraction } = useAnalytics();

  // Ürün görüntüleme takip et
  const trackProductView = useCallback((product) => {
    if (!product || !product.id) return;

    trackProductInteraction(
      product.id,
      'view',
      product.name,
      product.price,
      product.category,
      product.brand,
      product.image,
      product.url || `/product/${product.id}`,
      {
        quantity: 1,
        color: product.color,
        storage: product.storage,
        model: product.model
      }
    );
  }, [trackProductInteraction]);

  // Ürün tıklama takip et
  const trackProductClick = useCallback((product) => {
    if (!product || !product.id) return;

    trackProductInteraction(
      product.id,
      'click',
      product.name,
      product.price,
      product.category,
      product.brand,
      product.image,
      product.url || `/product/${product.id}`,
      {
        quantity: 1,
        color: product.color,
        storage: product.storage,
        model: product.model
      }
    );
  }, [trackProductInteraction]);

  // Ürünü sepete ekleme takip et
  const trackProductAddToCart = useCallback((product, quantity = 1) => {
    if (!product || !product.id) return;

    trackProductInteraction(
      product.id,
      'add_to_cart',
      product.name,
      product.price,
      product.category,
      product.brand,
      product.image,
      product.url || `/product/${product.id}`,
      {
        quantity,
        color: product.color,
        storage: product.storage,
        model: product.model
      }
    );
  }, [trackProductInteraction]);

  // Ürünü sepetten çıkarma takip et
  const trackProductRemoveFromCart = useCallback((product) => {
    if (!product || !product.id) return;

    trackProductInteraction(
      product.id,
      'remove_from_cart',
      product.name,
      product.price,
      product.category,
      product.brand,
      product.image,
      product.url || `/product/${product.id}`,
      {
        quantity: 1,
        color: product.color,
        storage: product.storage,
        model: product.model
      }
    );
  }, [trackProductInteraction]);

  // Ürün favorilere ekleme takip et
  const trackProductAddToFavorites = useCallback((product) => {
    if (!product || !product.id) return;

    trackProductInteraction(
      product.id,
      'add_to_favorites',
      product.name,
      product.price,
      product.category,
      product.brand,
      product.image,
      product.url || `/product/${product.id}`,
      {
        quantity: 1,
        color: product.color,
        storage: product.storage,
        model: product.model
      }
    );
  }, [trackProductInteraction]);

  // Ürün favorilerden çıkarma takip et
  const trackProductRemoveFromFavorites = useCallback((product) => {
    if (!product || !product.id) return;

    trackProductInteraction(
      product.id,
      'remove_from_favorites',
      product.name,
      product.price,
      product.category,
      product.brand,
      product.image,
      product.url || `/product/${product.id}`,
      {
        quantity: 1,
        color: product.color,
        storage: product.storage,
        model: product.model
      }
    );
  }, [trackProductInteraction]);

  return {
    trackProductView,
    trackProductClick,
    trackProductAddToCart,
    trackProductRemoveFromCart,
    trackProductAddToFavorites,
    trackProductRemoveFromFavorites
  };
};

export default useProductTracking;